export const SHARED = Object.freeze({
    DEFAULT_LAYOUT: 'app-layout',
    PUBLIC_LAYOUT: 'app-layout-public',
    EMPTY_LAYOUT: 'app-layout-empty',
    DEFAULT_LANGUAGE: 'en',
    FALLBACK_LANGUAGE: 'en',
    DEFAULT_ALL_VALUE: -1,
    DEFAULT_ALL_VALUE_STR: '',
    DEFAULT_PAGE_NUMBER: 1,
    DEFAULT_PAGE_SIZE: 10,
    USER_IDLE_TIME: process.env.VUE_APP_USER_IDLE_TIME //3600000=60 Minutes
  })

  export const DATE = Object.freeze({
    LONG: 'DD-MMM-YYYY HH:mm:ss',
    SHORT: 'DD-MMM-YYYY',
    TIME: 'HH:mm:ss',
    TIME_SHORT: 'HH:mm',
    DATE_TIME_SHORT: 'DD-MMM-YYYY HH:mm',
    DATE_TIME_SHORT_TZ: 'DD-MMM-YYYY HH:mm [(GMT]Z[)]'
  })

  export const SESSION = Object.freeze({
    USER_ID: 'uuid',
    USER: 'user',
    USER_EMAIL: 'email',
    USER_NAME: 'name',
    JWT_TOKEN: 'token',
    USER_TYPE: 'userType',
    TOKEN_EXPIRY_TIME: 'authTokenExpiryTime',
    REFRESH_TOKEN_EXPIRY_TIME: 'authRefreshTokenExpiryTime',
    PERMISSIONS: 'permissions',
    COUNTRY_CODES: 'countryCodes',
    USER_SEARCH: 'userSearch',
    ROLE_SEARCH: 'roleSearch',
    STAFF_SEARCH: 'staffSearch',
    STAFF_TYPE_SEARCH: 'staffTypeSearch',
    COMPANY_SIZE_SEARCH: 'companySizeSearch',
    COMPANY_SEARCH: 'companySearch',
    COMPANY_LOCATION_SEARCH: 'companyLocationSearch',
    MENU_SEARCH: 'menuSearch',
    PACKAGE_SEARCH: 'packageSearch',
    SERVICE_SEARCH: 'serviceSearch',
    PERIOD_SEARCH: 'periodSearch',
    CHECK_POINT_SEARCH: 'checkPointSearch',
    TRANSACTION_SEARCH: 'transactionSearch',
    INSPECTION_REPORT_SEARCH: 'inspectionReportSearch',
    REPORT_SEARCH: 'reportSearch',
    ORDER_SEARCH: 'orderSearch',
    VEHICLE_SEARCH: 'vehicleSearch',
    CUSTOMER_SEARCH: 'customerSearch',
    PURPOSE_SEARCH: 'purpose_search',
    QUERY_STATUS_SEARCH: 'query_status_search',
    REGISTRATION_STATUS_SEARCH: 'registration_status_search',
    RISK_STATUS_SEARCH: 'risk_status_search',
    SOURCE_SEARCH: 'source_search',
    STATUS_SEARCH: 'status_search',
    TYPE_SEARCH: 'type_search',
    DOCUMENT_SEARCH: 'document_search',
    STAFF_USER_ID: 'staffUuid',
    STAFF_USER: 'staffUser',
    STAFF_USER_EMAIL: 'staffEmail',
    STAFF_USER_IMAGE: 'staffUserImage',
    STAFF_USER_NAME: 'staffName',
    STAFF_JWT_TOKEN: 'staffToken',
    STAFF_TOKEN_EXPIRY_TIME: 'staffAuthTokenExpiryTime',
    STAFF_REFRESH_TOKEN_EXPIRY_TIME: 'staffAuthRefreshTokenExpiryTime',
    STAFF_COMPANY_NAME: 'staffCompanyName',
    STAFF_COMPANY_UUID: 'staffCompanyUUID',
    STAFF_LOCATION_NAME: 'staffLocationName',
    STAFF_LOCATION_UUID: 'staffLocationUUID',
    GROUP_SEARCH: 'groupSearch',
    GROUP_CONFIGURATION_SEARCH: 'groupConfigurationSearch',
    DEPARTMENT_SEARCH: 'departmentSearch',
    JOB_SEARCH: 'jobSearch',
    LOCATION_SEARCH: 'locationSearch',
    ASSET_TENANT_SEARCH: 'assetTenantSearch',
    GLOBAL_FILTER: 'globalFilter',
    USERS: 'users',
    MEETING_ROOM_SEARCH: 'meetingRoomSearch',
    MEETING_ROOM_BOOKING_SEARCH: 'meetingRoomBookingSeaerch',
    AMENITY_SEARCH: 'amenitySearch',
    SUPPLIER_SEARCH: 'supplierSearch',
    DOMAIN_SEARCH: 'domainSearch',
    DOMAIN_RESULTS_SEARCH: 'domainResultsSearch',
    DOMAIN_GROUP_SEARCH: 'domainGroupSearch',
    CONFIGURATION_SEARCH: 'configurationSearch',
  })

  export const APIHELPER = Object.freeze({
    NETWORK_ERROR: "Network Error", 
    UNKNOWN_ERROR: "Unknown Error", 
    INVALID_USER: "Invalid User", 
    OBJECT: "object", 
    OBJECT_INVALID: " is Invalid", 
    NETWORK_ERROR_CODE: "0.96", 
    UNKNOWN_ERROR_CODE: "0.99", 
  })

  export const MODULE = Object.freeze({
    AI: 1,
    BRAND: 2,
    CATEGORY: 3,
    CLASS: 4,
    FORM: 5,
    MOA: 6,
    PRINTER_PROOF: 7,
    PURPOSE: 8,
    QUERY_STATUS: 9,
    REGISTARTION_STATUS: 10,
    RISK_STATUS: 11,
    SOURCE: 12,
    STATUS: 13,
    TYPE: 14,
  })

  export const API = Object.freeze({
    BASE_URL: process.env.VUE_APP_API_BASE_URL,
    BASE_IMAGE_URL: process.env.VUE_APP_BASE_URL,
    S3_IMAGE_URL: process.env.VUE_APP_S3_URL,
  })



  // Markets a domain can be monitored in. Keep in step with
  // App\Constants\CountryCodeConstants on the Laravel side.
  export const MONITOR_COUNTRY_CODES = Object.freeze(['AU', 'MY', 'SG', 'CN', 'US'])
